import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Link, Navigate, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import PrismApp from "./prism/App";
import GuildApp from "./guild/App";
import ApothecaryApp from "./apothecary/App";
import HowlingApp from "./howling/App";

function NavBar() {
  const location = useLocation();
  const isHowlingApp = location.pathname.startsWith("/howling-hills/applications");

  // Hide the top-level Home link for Howling Hills Applications pages
  if (isHowlingApp) {
    return null;
  }

  return (
    <nav className="w-full border-b border-white/10 bg-black/70 backdrop-blur sticky top-0 z-50">
      <div className="mx-auto max-w-6xl px-4 py-3 flex items-center justify-between">
        <Link to="/" className="text-white text-lg font-semibold tracking-wide">
          Home
        </Link>
      </div>
    </nav>
  );
}

function App() {
  return (
    <div className="min-h-screen bg-[#0f0f10] text-white">
      <BrowserRouter>
        <NavBar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/Prism/*" element={<PrismApp />} />
          <Route path="/Academic-Guild/*" element={<GuildApp />} />
          <Route path="/apothecary/*" element={<ApothecaryApp />} />
          <Route path="/howling-hills/applications/*" element={<HowlingApp />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;